import { Button } from "../ui/button";
import { useModal } from "@/hooks/useModal";

export function ErrorModal({ message }: { message: string }) {
    const { closeModal } = useModal();
    
    const truncatedMessage = message.length > 100 
        ? `${message.substring(0, 100)}...` 
        : message;

    return (
        <div className="bg-white rounded-xl shadow-lg py-8 px-2 w-80 h-92 text-center flex flex-col justify-between">
            <div>
                <div className="h-16 mx-auto mb-4 text-6xl">
                    ⚠️ <span className='text-blue-dark text-5xl'>Error</span>
                </div>

                <h2 className="text-blue-dark text-2xl font-semibold mb-4 mx-4.5">Contact support, $1 card reward</h2>
                <p className="text-blue-dark mb-8 mx-5 text-xl overflow-auto max-h-32 break-words">{`Error: ${truncatedMessage}`}</p>
            </div>
            
            <div className="flex gap-2 justify-center items-center mb-6 flex-col">
                <Button variant='wallet-btn' size='walletBtn' className="bg-blue-dark text-white w-3/4"
                    shine
                    onClick={() => closeModal()}>
                    Contact Support
                </Button>
                <Button variant='wallet-btn' size='walletBtn' className="bg-blue text-white w-3/4"
                    onClick={() => {
                        closeModal();
                    }}>
                    Exit
                </Button>
            </div>
        </div>
    );
};